import {Pipe, PipeTransform} from '@angular/core';
import {UserProfileService} from '@ui-app/services/user-profile.service';

@Pipe({
    name: 'byRole'
})
export class ByRolePipe implements PipeTransform {
    constructor(private userProfileService: UserProfileService) {
    }

    transform(roles: number[], ...args: unknown[]): unknown {
        if (roles && roles.length) {
            const currentUser = this.userProfileService.user;
            return roles.includes(currentUser.userRoleId);
        } else {
            return true;
        }
    }

}
